import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PDV from "./pages/PDV";
import Products from "./pages/Products";
import ServiceOrders from "./pages/ServiceOrders";
import Financial from "./pages/Financial";
import Customers from "./pages/Customers";
import Suppliers from "./pages/Suppliers";
import Employees from "./pages/Employees";
import Messages from "./pages/Messages";
import PhoneIdentifier from "./pages/PhoneIdentifier";
import InfinitePayPage from "./pages/InfinitePay";
import ImportNF from "./pages/ImportNF";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Catalog from "./pages/Catalog";
import Fiscal from "./pages/Fiscal";
import Expenses from "./pages/Expenses";
import TrackOrder from "./pages/TrackOrder";
import ImeiLookup from "./pages/ImeiLookup";
import UpClubAdmin from "./pages/UpClubAdmin";
import WhatsAppAI from "./pages/WhatsAppAI";
import ServicesCatalog from "./pages/ServicesCatalog";
import Automations from "./pages/Automations";
import UpClubResult from "./pages/UpClubResult";
import UpClubManage from "./pages/UpClubManage";
import UpClubJoin from "./pages/UpClubJoin";
import ConnectionStatus from "./components/ConnectionStatus";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ConnectionStatus />
          <Routes>
            <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/track/:id" element={<TrackOrder />} />
            <Route path="/upclub/success" element={<UpClubResult status="success" />} />
            <Route path="/upclub/failure" element={<UpClubResult status="failure" />} />
            <Route path="/upclub/pending" element={<UpClubResult status="pending" />} />
            <Route path="/upclub/manage" element={<UpClubManage />} />
            <Route path="/upclub" element={<UpClubJoin />} />
            <Route path="/upclub/join" element={<UpClubJoin />} />
            <Route
              path="/app"
              element={<ProtectedRoute><Layout /></ProtectedRoute>}
            >
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="pdv" element={<PDV />} />
              <Route path="products" element={<Products />} />
              <Route path="import-nf" element={<ImportNF />} />
              <Route path="service-orders" element={<ServiceOrders />} />
              <Route path="phone-identifier" element={<PhoneIdentifier />} />
              <Route path="infinitepay" element={<InfinitePayPage />} />
              <Route path="financial" element={<Financial />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="imei-lookup" element={<ImeiLookup />} />
              <Route path="customers" element={<Customers />} />
              <Route path="suppliers" element={<Suppliers />} />
              <Route path="employees" element={<Employees />} />
              <Route path="messages" element={<Messages />} />
              <Route path="reports" element={<Reports />} />
              <Route path="fiscal" element={<Fiscal />} />
              <Route path="up-club" element={<UpClubAdmin />} />
              <Route path="whatsapp-ai" element={<WhatsAppAI />} />
              <Route path="services-catalog" element={<ServicesCatalog />} />
              <Route path="automations" element={<Automations />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
